import Link from 'next/link';
import Session from '@/components/Session';

export default function Destination() {
    return (
        <>
            <Session className='destination'>
                <div className='title'>Destinations</div>
                <div className='destinations'>
                    <Link
                        className='item'
                        href='https://www.trip.com/hotels/list?city=58&allianceid=3316851&sid=14848606'
                        target='_blank'
                    >
                        <img
                            className='bg'
                            style={{
                                backgroundImage: `url(https://ak-d.tripcdn.com/images/0a102120009skbpsbE251.png)`,
                            }}
                            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAZCAQAAAAyag7MAAAAI0lEQVR42mNkoDlgHLVi1IpRK0atGLVi1IpRK0atGLWCLAAAh1oAGoRzQQcAAAAASUVORK5CYII='
                        />
                        <img
                            className='bg-mobile'
                            style={{
                                backgroundImage: `url(https://ak-d.tripcdn.com/images/0a102120009skbpsbE251.png)`,
                            }}
                            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAQAAACx6dw/AAAAC0lEQVR42mNkAAMAAA4AAjOwv9wAAAAASUVORK5CYII='
                        />
                        <div className='name'>
                            <span>Hong Kong</span>
                        </div>
                    </Link>
                    <Link
                        className='item'
                        href='https://www.trip.com/hotels/list?city=73&allianceid=3316851&sid=14848606'
                        target='_blank'
                    >
                        <img
                            className='bg'
                            style={{
                                backgroundImage: `url(https://ak-d.tripcdn.com/images/0a11h120009t09s3k782E.png)`,
                            }}
                            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAZCAQAAAAyag7MAAAAI0lEQVR42mNkoDlgHLVi1IpRK0atGLVi1IpRK0atGLWCLAAAh1oAGoRzQQcAAAAASUVORK5CYII='
                        />
                        <img
                            className='bg-mobile'
                            style={{
                                backgroundImage: `url(https://ak-d.tripcdn.com/images/0a11h120009t09s3k782E.png)`,
                            }}
                            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAQAAACx6dw/AAAAC0lEQVR42mNkAAMAAA4AAjOwv9wAAAAASUVORK5CYII='
                        />
                        <div className='name'>
                            <span>Singapore</span>
                        </div>
                    </Link>
                    <Link
                        className='item'
                        href='https://www.trip.com/hotels/list?city=359&allianceid=3316851&sid=14848606'
                        target='_blank'
                    >
                        <img
                            className='bg'
                            style={{
                                backgroundImage: `url(https://ak-d.tripcdn.com/images/0a11g120009t0kvigAE04.png)`,
                            }}
                            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAZCAQAAAAyag7MAAAAI0lEQVR42mNkoDlgHLVi1IpRK0atGLVi1IpRK0atGLWCLAAAh1oAGoRzQQcAAAAASUVORK5CYII='
                        />
                        <img
                            className='bg-mobile'
                            style={{
                                backgroundImage: `url(https://ak-d.tripcdn.com/images/0a11g120009t0kvigAE04.png)`,
                            }}
                            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAQAAACx6dw/AAAAC0lEQVR42mNkAAMAAA4AAjOwv9wAAAAASUVORK5CYII='
                        />
                        <div className='name'>
                            <span>Bangkok</span>
                        </div>
                    </Link>
                </div>
            </Session>
        </>
    );
}
